import { createContext } from 'react'

const AccessContext = createContext({ isAdmin: false })

export default AccessContext
